import { MY_TEAMS_ADVISOR } from '@zet/constants'
import { B2 } from '@zet/design-system/typography'
import { APP_NAME } from '@zet/end-points'
import { i18n } from '@zet/localization'

interface commissionTypeProps {
  commissionType: string
  brandCommission: string | number
}
const CommissionType: React.FC<commissionTypeProps> = (props) => {
  const { commissionType, brandCommission } = props
  if (APP_NAME === MY_TEAMS_ADVISOR) {
    return <></>
  }
  return (
    <B2 className="text-success-100">
      {i18n.t(
        commissionType === 'flat'
          ? 'myLeads.cashFlat'
          : 'myLeads.cashPercentage',
        {
          brandCommission: brandCommission,
        }
      )}
    </B2>
  )
}

export default CommissionType
